
namespace RecordShield.Wallet {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class CouponsDialog extends Serenity.EntityDialog<CouponsRow, any> {
        protected getFormKey() { return CouponsForm.formKey; }
        protected getIdProperty() { return CouponsRow.idProperty; }
        protected getLocalTextPrefix() { return CouponsRow.localTextPrefix; }
        protected getNameProperty() { return CouponsRow.nameProperty; }
        protected getService() { return CouponsService.baseUrl; }

        protected form = new CouponsForm(this.idPrefix);

        constructor() {
            super();
            debugger;
            this.form.CouponType.changeSelect2(e => {
                debugger;
                var id = Q.toId(this.form.CouponType.value);
                if (id == 1) {
                    this.form.NoOfInstance.value = null;
                    this.form.NoOfInstance.getGridField().toggle(false);
                }

                if (id == 2) {
                    this.form.NoOfInstance.getGridField().toggle(true);
                }
            });

            this.form.DiscountType.changeSelect2(e => {
                debugger;
                var id = Q.toId(this.form.DiscountType.value);
                if (id == 1) {
                    this.form.DiscountAmount.getGridField().toggle(true);
                    this.form.DiscountPercentage.value = null;
                    this.form.DiscountPercentage.getGridField().toggle(false);
                }

                if (id == 2) {
                    this.form.DiscountAmount.value = null;
                    this.form.DiscountAmount.getGridField().toggle(false);
                    this.form.DiscountPercentage.getGridField().toggle(true);
                }
            });
        }
        protected validateBeforeSave() {
            var isValidate = super.validateForm();
            if (isValidate) {
                isValidate = super.validateBeforeSave();
            }
            debugger;
            if (this.form.CouponType.value == "2" &&  !this.form.NoOfInstance.value) {
                Q.alert("Please Enter no Of Instance");
                return false;
            }
            if (this.form.DiscountType.value == "1")
                if (!this.form.DiscountAmount.value) {
                Q.alert("Please Enter Discount Amount");
                return false;
            }
            if (this.form.DiscountType.value == "2")
                if (!this.form.DiscountPercentage.value) {
                Q.alert("Please Enter Discount Percentage");
                return false;
            }
            return isValidate;


        }
        loadEntity(entity: CouponsRow) {
            super.loadEntity(entity);
            debugger;
            if (this.isNewOrDeleted()) {
                this.form.DiscountAmount.getGridField().toggle(false);
                this.form.DiscountPercentage.getGridField().toggle(false);
                this.form.NoOfInstance.getGridField().toggle(false);
            }
            else {
                if (this.form.CouponType.value == "1") {
                   
                    this.form.NoOfInstance.getGridField().toggle(false);
                }
                else
                    this.form.NoOfInstance.getGridField().toggle(true);
                var id = Q.toId(this.form.DiscountType.value);
                if (id == 1) {
                    this.form.DiscountAmount.getGridField().toggle(true);
                    this.form.DiscountPercentage.value = null;
                    this.form.DiscountPercentage.getGridField().toggle(false);
                }

                if (id == 2) {
                    this.form.DiscountAmount.value = null;
                    this.form.DiscountAmount.getGridField().toggle(false);                   
                    this.form.DiscountPercentage.getGridField().toggle(true);
                }
                Serenity.EditorUtils.setReadonly(this.form.CouponCode.element, true);
            }
        }
    }
}